export default __webpack_public_path__ + "static/media/Beard_6_C5.81b80dc4.svg";